<div class="dialog-overlay">
    <div class="dialog-container">
        <div class="dialog-content">
            <div class="dialog-header__title">
                {{ 'aumico_add_new_notes_component_title' | i18next }}
            </div>
            <div class="notes-cards-container">
                <div
                    *ngFor="let component of notesComponents"
                    [ngClass]="{
                        'hidden-component': !component.shouldBeVisibleForUser && !supportOperation
                    }"
                >
                    <div
                        *ngIf="component.shouldBeVisibleForUser || supportOperation"
                        [ngClass]="{
                            'notes-card': true,
                            selected: selectedNoteComponent === component.componentName
                        }"
                        (click)="onSelectComponent(component.componentName)"
                    >
                        <div class="notes-card-content">
                            <img [src]="component.imagePath" [alt]="component.componentType" />
                            <div class="notes-card__title">
                                {{ component.title | i18next }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="showClipboard"
                    [ngClass]="{
                        'notes-card': true,
                        selected: pasteComponentSelected,
                        'background-highlight': true
                    }"
                    (click)="onPasteComponent()"
                >
                    <div class="notes-card-content">
                        <img [src]="componentInClipboardImagePath" />
                        <div class="notes-card__title">
                            {{ 'aumico_add_new_notes_paste_from_clipboard' | i18next }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-top-separator"></div>
        <div class="dialog-footer">
            <ham-button [size]="'sm'" (click)="onAddComponent()">{{
                'aumico_add_new_notes_component_button' | i18next
            }}</ham-button>
        </div>
    </div>
</div>
